import { forwardRef, useImperativeHandle, useRef } from 'react';
import { cx } from '@chakra-ui/utils';
import { useTranslation } from 'react-i18next';

import { InputControlProps } from '../../../@types';
import { createLogLocal } from '../../../utils/createLogLocal';

import { SelectControl } from './SelectControl';

const log = createLogLocal('DocTypeControl.tsx');

export const DocTypeControl = forwardRef((props: InputControlProps, ref) => {
  const { t } = useTranslation();
  const inputRef = useRef();

  const typeList = [
    {
      name: t('passport'),
      value: 'passport',
    },
    {
      name: t('thaiId'),
      value: 'thaiId',
    },
  ];

  useImperativeHandle(ref, () => ({
    beforeSubmit() {
      log('DocTypeControl beforeSubmit does nothing.');
    },
    async validate() {
      await (inputRef.current as any)?.validate();
    },
  }));

  return (
    <SelectControl
      ref={inputRef}
      className={cx('card-form-select-input')}
      // TODO: fix this mess
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      list={typeList}
      {...props}
    />
  );
});
